"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchEmailNotifications: ()=>fetchEmailNotifications,
    acceptEmailNotification: ()=>acceptEmailNotification,
    deleteEmailNotification: ()=>deleteEmailNotification,
    useEmailNotifications: ()=>useEmailNotifications,
    useAcceptEmailNotification: ()=>useAcceptEmailNotification,
    useDeleteEmailNotification: ()=>useDeleteEmailNotification
});
const _reactQuery = require("react-query");
const _ = require("..");
const fetchEmailNotifications = async (walletId)=>{
    const response = await _.api.get(`/wallet/v1/members/${walletId}/email_notifications`);
    return response || {
        email: '',
        last_email_confirmation_sent_at: null,
        notifications: []
    };
};
const acceptEmailNotification = async ({ walletId , notificationId , email  })=>{
    // Ensure notificationId is a number
    const id = Number(notificationId);
    if (isNaN(id)) {
        throw new Error(`Invalid notificationId: ${notificationId}`);
    }
    await _.api.post(`/wallet/v1/members/${walletId}/email_notifications/${id}/accept`, email ? {
        email
    } : {});
};
const deleteEmailNotification = async ({ walletId , notificationId  })=>{
    await _.api.delete(`/wallet/v1/members/${walletId}/email_notifications/${notificationId}`);
};
const useEmailNotifications = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useQuery)([
        'emailNotifications',
        walletId
    ], ()=>fetchEmailNotifications(walletId), {
        enabled: !!walletId,
        refetchOnWindowFocus: true,
        refetchOnMount: true
    });
};
const useAcceptEmailNotification = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(({ notificationId , email  })=>acceptEmailNotification({
            walletId: walletId,
            notificationId,
            email
        }), {
        onSuccess: ()=>{
            // Invalidate and refetch notifications
            queryClient.invalidateQueries([
                'emailNotifications',
                walletId
            ]);
        }
    });
};
const useDeleteEmailNotification = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((notificationId)=>deleteEmailNotification({
            walletId: walletId,
            notificationId
        }), {
        onSuccess: ()=>{
            // Invalidate and refetch notifications
            queryClient.invalidateQueries([
                'emailNotifications',
                walletId
            ]);
        }
    });
};
